import axios from 'axios';
import * as XLSX from 'xlsx';

// import S3 from 'aws-sdk/clients/s3';
import { history } from '../Routing/History';
import { isWebView } from './utilities';
// import { apiValidation } from './utilities';
// import { loadingActions } from '../redux/actions/loading.action';

function authHeaderPost() {
  // return authorization header with jwt token
  const storedState = localStorage.getItem('state');
  let token = null;

  try {
    token = JSON.parse(storedState)?.userProfile?.token;
  } catch (e) {
    console.error('Error parsing localStorage state:', e);
  }

  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Seq-Auto-Fetch': 'cors', // pharzi for security layer - no significance
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return { headers };
}

let modee = process.env.NODE_ENV;

export const serverUrl =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3000'
    : 'https://class.ingeniumedu.com';



const transformRequest = (jsonData = {}) =>
  Object.entries(jsonData)
    .map((x) => `${encodeURIComponent(x[0])}=${encodeURIComponent(x[1])}`)
    .join('&');

export const post = (requestBody, endpoint) => {
  return axios
    .post(serverUrl + endpoint, transformRequest(requestBody), authHeaderPost())
    .then((result) => result.data)
    .catch((err) => {
      console.error(`The error is ${err}`);
    });
};

function authHeaderGet() {
  // return authorization header with jwt token
  const { token } = JSON.parse(localStorage.getItem('state')).userProfile;

  if (token) {
    return {
      Authorization: `Bearer ${token}`,
      'Seq-Auto-Fetch': 'cors', // pharzi for security layer - no significance
    };
  }
  return { 'Seq-Auto-Fetch': 'cors' };
}

export const get = (requestBody = null, endpoint) => {
  // requestBody must be an object
  return axios
    .get(serverUrl + endpoint, { params: requestBody, headers: authHeaderGet() })
    .then((result) => result.data)
    .catch((err) => {
      // history.push('/error');
      console.error(`The error is ${err}`);
    });
};

export const uploadImage = (file, feature, clientId) => {
  if (!clientId) return;
  const fd = new FormData();
  fd.append('upl', file);
  fd.append('client_id', clientId); // Client ID
  fd.append('feature', feature); // Feature

  return axios
    .post(`${serverUrl}/upload`, fd, {
      headers: {
        'Content-Type': 'multipart/form-data', // Changed this
        'Seq-Auto-Fetch': 'cors', // Dont Changed this, security
      },
      // No need for transformRequest when using FormData
    })
    .then((result) => result.data)
    .catch((err) => {
      history.push('/error');
      console.error(`The error is ${err}`);
    });
};

export const uploadFiles = (files) => {
  const fd = new FormData();
  files.forEach(({ file, type }) => {
    fd.append('upl', file, `${file.name}|${type}`);
  });
  console.log(files);
  return axios
    .post(`${serverUrl}/multipleUpload`, fd, authHeaderPost())
    .then((result) => result.data)
    .catch((err) => {
      console.error(`The error is ${err}`);
    });
};

/* eslint-disable */
export const convertCSVToPdfAndDownload = (JSONData, ReportTitle, ShowLabel) => {
  if (isWebView) {
    const data = JSON.parse(JSONData);
    if (!data) return;
    if (!data.length) return;
    const keysArr = Object.keys(data[0]);
    let valuesArr = [];
    data.forEach((d) => {
      valuesArr.push(Object.values(d).map((e) => String(e)));
    });

    if (typeof window.Android.convertCSVToPdfAndDownload !== 'undefined') {
      window.Android.convertCSVToPdfAndDownload(
        JSON.stringify({
          fileName: `${ReportTitle}_${String(Math.floor(new Date().getTime() / 1000)).slice(
            -5,
          )}.pdf`,
          array: [keysArr, ...valuesArr],
        }),
      );
    } else if (typeof window.Android.createCSVAndDownload !== 'undefined') {
      window.Android.createCSVAndDownload(
        JSON.stringify({
          fileName: `${ReportTitle}_${String(Math.floor(new Date().getTime() / 1000)).slice(
            -5,
          )}.csv`,
          array: [keysArr, ...valuesArr],
        }),
      );
    }
  } else {
    //  If JSONData is not an object then JSON.parse will parse the JSON string in an Object
    const arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;

    let CSV = ',' + '\r\n\n';

    //  This condition will generate the Label/Header
    if (ShowLabel) {
      let row = '';

      //  This loop will extract the label from 1st index of on array
      for (let index in arrData[0]) {
        //  Now convert each value to string and comma-seprated
        row += index + ',';
      }

      row = row.slice(0, -1);

      //  append Label row with line break
      CSV += row + '\r\n';
    }

    //  1st loop is to extract each row
    for (let i = 0; i < arrData.length; i++) {
      let row = '';

      //  2nd loop will extract each column and convert it in string comma-seprated
      for (let index in arrData[i]) {
        row += '"' + arrData[i][index] + '",';
      }

      row.slice(0, row.length - 1);

      //  add a line break after each row
      CSV += row + '\r\n';
    }

    if (CSV == '') {
      alert('Invalid data');
      return;
    }

    //  Generate a file name
    let fileName = 'Report_';
    //  this will remove the blank-spaces from the title and replace it with an underscore
    fileName += ReportTitle.replace(/ /g, '_');

    //  Initialize file format you want csv or xls
    let uri = 'data:text/csv;charset=utf-8,' + escape(CSV);

    // Now the little tricky part.
    // you can use either>> window.open(uri);
    // but this will not work in some browsers
    // or you will not get the correct file extension

    //  this trick will generate a temp <a /> tag
    const link = document.createElement('a');
    link.href = uri;
    // link.target = '_blank';

    //  set the visibility hidden so it will not effect on your web-layout
    link.style = 'visibility:hidden';
    link.download = fileName + '.csv';

    //  this part will append the anchor tag and remove it after automatic click
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

export const json2xlsDownload = (JSONData, ReportTitle, ShowLabel, config = {}) => {
  if (isWebView) {
    const data = JSON.parse(JSONData);
    if (!data || !data.length) return;

    const keysArr = Object.keys(data[0]);
    const valuesArr = data.map((d) => Object.values(d).map((e) => String(e)));

    if (typeof window.Android.createCSVAndDownload !== 'undefined') {
      window.Android.createCSVAndDownload(
        JSON.stringify({
          fileName: `${ReportTitle}_${String(Math.floor(new Date().getTime() / 1000)).slice(
            -5,
          )}.csv`,
          array: [keysArr, ...valuesArr],
        }),
      );
    }
  } else {
    const arrData = typeof JSONData !== 'object' ? JSON.parse(JSONData) : JSONData;
    if (!arrData || !arrData.length) {
      alert('Invalid data');
      return;
    }

    const fileName = `Report_${ReportTitle.replace(/ /g, '_')}`;

    // Use SheetJS path only when config options are passed
    if (config && Object.keys(config).length > 0) {
      const headers = ShowLabel ? Object.keys(arrData[0]) : [];
      const rows = arrData.map((item) => Object.values(item));
      const sheetData = ShowLabel ? [headers, ...rows] : rows;

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.aoa_to_sheet(sheetData);

      if ((config.wrap_heading || config.bold_heading) && ShowLabel && headers.length) {
        headers.forEach((_, colIndex) => {
          const cellRef = XLSX.utils.encode_cell({ r: 0, c: colIndex });
          if (ws[cellRef]) {
            ws[cellRef].s = {
              alignment: config.wrap_heading
                ? { wrapText: true, vertical: 'center', horizontal: 'center' }
                : undefined,
              font: config.bold_heading ? { bold: true } : undefined,
            };
          }
        });
      }

      ws['!cols'] = headers.map((header, colIndex) => {
        const maxLen = Math.max(
          String(header).length,
          ...arrData.map((row) => String(Object.values(row)[colIndex] ?? '').length),
        );
        return { wch: Math.min(maxLen + 2, 50) };
      });

      XLSX.utils.book_append_sheet(wb, ws, 'Report');
      XLSX.writeFile(wb, `${fileName}.xlsx`);
    } else {
      // ✅ Original CSV path — untouched except the empty rows bug fix
      let CSV = ''; // Fix: was ',' + '\r\n\n' which caused 2 empty rows

      if (ShowLabel) {
        let row = '';
        for (let index in arrData[0]) {
          row += index + ',';
        }
        row = row.slice(0, -1);
        CSV += row + '\r\n';
      }

      for (let i = 0; i < arrData.length; i++) {
        let row = '';
        for (let index in arrData[i]) {
          row += '"' + arrData[i][index] + '",';
        }
        row = row.slice(0, row.length - 1);

        CSV += row + '\r\n';
      }

      if (CSV === '') {
        alert('Invalid data');
        return;
      }

      const uri = 'data:text/csv;charset=utf-8,' + escape(CSV);
      const link = document.createElement('a');
      link.href = uri;
      link.style = 'visibility:hidden';
      link.download = fileName + '.csv';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};

export const mode = modee;

export const server =
  process.env.NODE_ENV === 'development'
    ? // Dev sockets must hit the LOCAL backend (same as serverUrl/REST above).
      // Pointing them at prod made dev REST writes go to the local server while
      // socket traffic (join/sendMessage/receiveMessage) went to the deployed
      // prod server, whose older code can't handle new conversation types.
      'http://localhost:3000'
    : window.location.origin.includes('https://portal.ingeniumedu.com')
    ? 'https://portal.ingeniumedu.com'
    : 'https://class.ingeniumedu.com';

// ==================== PINNED MESSAGES APIs ====================

export const pinMessage = (conversation_id, chat_id, client_user_id) => {
  return post(
    {
      conversation_id,
      chat_id,
      client_user_id,
    },
    '/pinMessage',
  );
};

export const unpinMessage = (conversation_id, chat_id, client_user_id) => {
  return post(
    {
      conversation_id,
      chat_id,
      client_user_id,
    },
    '/unpinMessage',
  );
};

export const getPinnedMessages = (conversation_id) => {
  return get(
    {
      conversation_id,
    },
    '/getPinnedMessages',
  );
};

export const getLatestPinnedMessage = (conversation_id) => {
  return get(
    {
      conversation_id,
    },
    '/getLatestPinnedMessage',
  );
};

export const isMessagePinned = (conversation_id, chat_id, callback) => {
  get(
    {
      conversation_id,
      chat_id,
    },
    '/isMessagePinned',
  ).then((res) => {
    if (res && res.success && res.result && res.result.length > 0) {
      callback(true);
    } else {
      callback(false);
    }
  }).catch((err) => {
    console.error('Error checking if message is pinned:', err);
    callback(false);
  });
};

export const editMessage = (chat_id, new_text, client_user_id) => {
  return post(
    {
      chat_id,
      new_text,
      client_user_id,
    },
    '/editMessage',
  );
};

export const isStaffChatEnabled = (client_id) => {
  return get(
    {
      client_id,
    },
    '/isStaffChatEnabled',
  );
};

export const getStaffForConversation = ({ search = '', page = 1, limit = 20 } = {}) => {
  return get(
    {
      search,
      page,
      limit,
    },
    '/getStaffForConversation',
  );
};

export const checkOrCreateStaffChat = (peer_client_user_id) => {
  return get(
    {
      peer_client_user_id,
    },
    '/checkOrCreateStaffChat',
  );
};
